import { NzTableFilterFn, NzTableSortFn } from 'ng-zorro-antd/table';

export type TableSortValue = string | number | null;

export function createTableSortFn<T>(getValue: (item: T) => TableSortValue): NzTableSortFn<T> {
  return (leftItem, rightItem) => compareTableSortValues(getValue(leftItem), getValue(rightItem));
}

export function compareTableSortValues(leftValue: TableSortValue, rightValue: TableSortValue): number {
  if (leftValue === null && rightValue === null) {
    return 0;
  }

  if (leftValue === null) {
    return 1;
  }

  if (rightValue === null) {
    return -1;
  }

  if (typeof leftValue === 'number' && typeof rightValue === 'number') {
    return leftValue - rightValue;
  }

  return leftValue.toString().localeCompare(rightValue.toString(), undefined, { numeric: true, sensitivity: 'base' });
}

export function createTableFilterFn<T>(
  getValue: (item: T) => string | string[] | null | undefined,
): NzTableFilterFn<T> {
  return (filterValue, item) => compareTableFilterValues(filterValue, getValue(item));
}

export function compareTableFilterValues(
  filterValue: string,
  itemValue: string | string[] | null | undefined,
): boolean {
  if (!itemValue) {
    return false;
  }

  if (Array.isArray(itemValue)) {
    return itemValue.some((value) => value.toLowerCase().includes(filterValue.toLowerCase()));
  }

  return itemValue.toLowerCase().includes(filterValue.toLowerCase());
}
